// extracted by mini-css-extract-plugin
export default {"wrap":"CardSwiper_wrap__1IH-7"};